/**
 * 下载文件
 * @param data
 * @param fileName
 */
import { getFlyNum } from "/@/api/sys/sys";
import { sysType } from "/@/types/task";
import { ELocalStorageKey } from "/@/types";
import pin2d8cf0 from "/@/assets/icons/pin-e23c39.svg";
import { ref, nextTick, unref } from "vue";
export function downloadFile(data: Blob, fileName: any) {
  const lable = document.createElement("a");
  lable.href = window.URL.createObjectURL(data);
  lable.download = fileName;
  lable.click();
  URL.revokeObjectURL(lable.href);
}
// 获取地图默认参数
export async function getMapDataApi() {
  const workspaceId: string =
    localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
  let mapFormState = {
    lng: 0,
    lat: 0,
    maps: 1,
    mapsxyz: [] as any,
  };
  const res = await getFlyNum({ sysName: sysType[2].key }, workspaceId);
  // console.log(93,res);
  const mapxyz = [
    {
      maps: 1, //cesium
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 2, //星图
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 3, //自有
      lng: 0,
      lat: 0,
      height: 0,
    },
    {
      maps: 4, //mapbox
      lng: 0,
      lat: 0,
      height: 0,
    },
  ];
  if (res.code == 0) {
    if (res?.data?.sys_value) {
      const sysValue = JSON.parse(res?.data?.sys_value);
      mapFormState.lng = sysValue?.lng ? parseFloat(sysValue?.lng) : 104.092518;
      mapFormState.lat = sysValue?.lat ? parseFloat(sysValue?.lat) : 30.654566;
      mapFormState.maps = sysValue?.maps ? sysValue?.maps : 1;
      mapFormState.mapsxyz = sysValue?.mapsxyz ? sysValue?.mapsxyz : mapxyz;
    } else {
      mapFormState.lng = 104.092518;
      mapFormState.lat = 30.654566;
      mapFormState.maps = 1;
      mapFormState.mapsxyz = mapxyz;
    }
  }
  return mapFormState;
}
// 地图图层、高程地址
export const mapUrlList = {
  // 星图的瓦片地址
  xin_imgUrl:
    "https://tiles1.geovisearth.com/base/v1/img/{z}/{x}/{y}?format=webp&tmsIds=w&token=b8930f0922848527e6d47b986094ca821134be9a34350d19d416eb6e3ad2cfce",
  //  星图的高程地址
  xin_treeain:
    "https://tiles1.geovisearth.com/base/v1/terrain?token=b8930f0922848527e6d47b986094ca821134be9a34350d19d416eb6e3ad2cfce",
  //  自有的瓦片地址
  // own_imgurl: "http://223.86.29.68:68/wapian/{z}/{x}/{y}/tile.png", // 广汉
  // own_imgurl: "http://125.70.13.132:8086/{z}/{x}/{y}/tile.png", // 科尔沁
  own_imgurl: "https://fly.cdjjhb.cn:1111/{z}/{x}/{y}/tile.png", // fly
  // own_imgurl:'http://112.19.171.189:1110/{z}/{x}/{y}/tile.png',
  // own_imgurl:'https://ga.cdrzwx.cn:1111/{z}/{x}/{y}/tile.png',
  // 自有的高程地址
  // own_treeain: "http://223.86.29.68:1887/height/", // 广汉
  // own_treeain: "http://125.70.13.132:8086/height/", // 科尔沁
  own_treeain: "https://fly.cdjjhb.cn/height/", // fly
  // own_treeain:'http://112.19.171.189:1113/',
  // own_treeain:'https://ga.cdrzwx.cn:1112/',
  // cesium的瓦片地址
  ces_imgurl1:
    "https://t0.tianditu.gov.cn/cia_w/wmts?tk=5af8222731253d990c26cf8e801f5482", // fly
  ces_imgurl2:
    "https://t0.tianditu.gov.cn/img_w/wmts?tk=5af8222731253d990c26cf8e801f5482", // fly
  // ces_imgurl1:
  //   "https://t0.tianditu.gov.cn/cia_w/wmts?tk=79f64855f887641ab0f40287acea1954", // 广汉 86159a97e90cd8b78b9b24380091b83b
  // ces_imgurl2:
  //   "https://t0.tianditu.gov.cn/img_w/wmts?tk=79f64855f887641ab0f40287acea1954", // 广汉
  ces_token: ["5af8222731253d990c26cf8e801f5482"], // cesium初始化使用天地图token    fly使用天地图token
  // ces_token: ["79f64855f887641ab0f40287acea1954"], // cesium初始化使用天地图token    广汉 使用天地图token
  // mapbox的瓦片地址(自定义样式)
  // mapbox_imgurl:
  //   "https://api.mapbox.com/styles/v1/35cd60rcdf/cm0n9bq4v001801pqbp9i7ei4/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiMzVjZDYwcmNkZiIsImEiOiJjbHczcndtdzkxMHluMmlscjRpZjRqOXl2In0.qp1uNmZpGLhouSpHvZNLng",
  // mapbox 瓦片地址（自带，标注是部分是英文）
  mapbox_imgurl:
    "https://api.mapbox.com/styles/v1/mapbox/dark-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoieXFoZXZ0ZmciLCJhIjoiY205emM3ZGNkMHNxZzJxb2wweDRkM3VwcSJ9.6K3OoUuIs1qvPWmrOZEU2Q",
  // arcgis 图层
  arcgisShow: false, // arcgis图层是否显示
  arcgis1:
    "https://api.cdmbc.cn:4432/gateway/gis/1/5e249977ce1b454eab17999b9122871e?AppKey=962000644045012992", // 锦江区 边界线
  arcgis2:
    "https://api.cdmbc.cn:4432/gateway/gis/1/8780d3715f054a0b948bb3a744d8ba34?AppKey=962000644045012992", // 锦江区 街道边界线
};
const mapBillboard = ref<any>([]);
// 绘制菱形
export function drawBuildMarker(viewer: any, pos: any, name: string) {
  if (!pos) {
    return;
  }
  if (!viewer) {
    return;
  }
  const position = Cesium.Cartesian3.fromDegrees(
    Number(pos[0]),
    Number(pos[1]),
    Number(pos[2] || 0),
  );
  let billboard = viewer.entities.add({
    position: position,
    billboard: {
      color: Cesium.Color.fromCssColorString("#fff").withAlpha(0.8),
      // color: new Cesium.Color(1.0,1.0,1.0,0.8),
      image: pin2d8cf0,
      scale: 2,
      // pixelOffset: this.style.pixelOffset,
      heightReference: 1,
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      // 按距离缩放
      scaleByDistance: new Cesium.NearFarScalar(1.5e2, 2, 20000, 0.0),
      eyeOffset: new Cesium.Cartesian3(0, 0, -90), //Label 被建筑物遮挡问题
    },
    label: {
      // text: '测试',
      text: name,
      // pixelOffset: this.style.pixelOffset, //偏移量
      pixelOffset: new Cesium.Cartesian2(25, -50), //偏移量
      font: "600 16px",
      // horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      heightReference: 1,
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      fillColor: Cesium.Color.fromCssColorString("#fff"), //字体颜色
      showBackground: true,
      backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0), //背景色
      // disableDepthTestDistance: Number.POSITIVE_INFINITY,
      eyeOffset: new Cesium.Cartesian3(0, 0, -100), //Label 被建筑物遮挡问题

      // 按距离缩放
      // scaleByDistance: new Cesium.NearFarScalar(1.5e2, 2, 20000, 0.0),
    },
  });
  mapBillboard.value.push(billboard);
}

// 销毁菱形
export function destoryBuildMarker(viewer: any) {
  // entityCollection.value.show = false;
  if (mapBillboard.value && mapBillboard.value.length > 0) {
    mapBillboard.value.map((item: any) => {
      viewer.entities.remove(item);
    });
    mapBillboard.value = [];
  }
}
// true:数组内的元素存在且不为NaN, false: 数组内的元素存在为空或NaN的情况
export function judgeArrNaN(arr: any) {
  if (Array.isArray(arr)) {
    for (let i = 0; i < arr.length; i++) {
      if (Array.isArray(arr[i])) {
        if (!arr[i] || !judgeArrNaN(arr[i])) {
          return false;
        }
      } else {
        if (!arr[i] || isNaN(arr[i])) {
          return false;
        }
      }
    }
    return true;
  } else {
    if (!arr || isNaN(arr)) {
      return false;
    }
    return true;
  }
}
// 判断数组元素是否有效
export function isValidArray(arr: any) {
  // console.log(183,arr);

  // 辅助函数：递归地处理数组元素
  function processElement(element: any) {
    if (Array.isArray(element)) {
      if (!judgeArrNaN(element)) {
        return [];
      }
      const result = element
        .map(processElement)
        .filter((el) => el != null) as any;
      // 只有处理后的子数组与原子数组长度相等时，才保留该子数组
      // console.log(1922,result);

      return result.length === element.length ? result : null;
    } else if (typeof element === "number") {
      return element;
    } else if (typeof element === "string" && !isNaN(Number(element))) {
      return Number(element);
    } else {
      return null;
    }
  }

  const result = processElement(arr);
  // 只保留最终结果为有效数组的部分
  return Array.isArray(result) ? result : [];
}
// 检查输入类型
export function safeParseFloat(value: any) {
  if (typeof value === "string" || typeof value === "number") {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? null : parsed; // 返回 null 或其他默认值
  }
  return null; // 如果类型不正确，返回 null 或其他默认值
}
// 隐藏姓名后面所有字符，只显示姓
export function hideName(name: any) {
  if (name) {
    if (name.length < 3) {
      // 获取姓氏
      const lastName = name.substr(0, 1);
      // 替换后面的字符为*
      const hiddenLength = name.length - 1;
      return lastName + "*".repeat(hiddenLength);
    } else {
      const reg = /^1[34578]\d{9}$/;
      if (reg.test(name)) {
        return name.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else {
        let str = name;
        const firstChar = str.charAt(0);
        const lastChar = str.charAt(str.length - 1);
        const middle = str.substring(1, str.length - 1).replace(/./g, "*");
        return firstChar + middle + lastChar;
      }
    }
  } else {
    return "";
  }
}
// 隐藏电话号码中间几位
export function hidePhone(phoneNumber: any) {
  // 判断字符串是否为合法的手机号码，例如 '13800138000'
  const reg = /^1[34578]\d{9}$/;
  if (phoneNumber) {
    if (reg.test(phoneNumber)) {
      return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    } else {
      return phoneNumber;
    }
  } else {
    return "";
  }
}
export function calcTableHeight(tableContainer: any, tableElRef: any) {
  // 示例：容器高度减去其他元素占用的空间
  const offset = 100; // 页眉/分页器 头部等高度
  if (!tableContainer) {
    return;
  }

  const tableHeight = tableContainer.clientHeight - offset;
  const height = Math.floor((tableHeight - 30) / 15);
  nextTick(() => {
    const tableEl = tableElRef?.$el;
    let bodyEl = tableEl.querySelector(".ant-table-body");
    bodyEl!.style.height = `${unref(tableHeight - 20)}px`;
    // 创建 <style> 元素
    const style = document.createElement("style");
    style.innerHTML = `
        .row-class {
          height: ${height}px !important;
          max-height: 100px;
          min-height: 38px;
        }
      `;
    // 添加到<head>
    document.head.appendChild(style);
  });
}
// 测试车辆轨迹
export function carlinedata() {
  const point = [
    [104.1087872, 30.6186112],
    [104.1088896, 30.6182976],
  ];
  return point;
}
